import {
  barcodeContent as gotoAccountBarcode,
  messages as gotoAccountMessages,
  hotkey as gotoAccountHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-account-settings';
import {
  barcodeContent as gotoCarrierBarcode,
  messages as gotoCarrierMessages,
  hotkey as gotoCarrierHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-carrier-fulfullment-settings';
import {
  barcodeContent as gotoCustomersBarcode,
  messages as gotoCustomersMessages,
  hotkey as gotoCustomersHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-customers';
import {
  barcodeContent as gotoOrdersBarcode,
  messages as gotoOrdersMessages,
  hotkey as gotoOrdersHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-orders';
import {
  barcodeContent as gotoPrintBarcode,
  messages as gotoPrintMessages,
  hotkey as gotoPrintHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-print-setup-settings';
import {
  barcodeContent as gotoProductsBarcode,
  messages as gotoProductsMessages,
  hotkey as gotoProductsHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-products-inventory';
import {
  barcodeContent as gotoProductsInventoryBarcode,
  messages as gotoProductsInventoryMessages,
  hotkey as gotoProductsInventoryHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-products';
import {
  barcodeContent as gotoShipmentsBatchesBarcode,
  messages as gotoShipmentsBatchesMessages,
  hotkey as gotoShipmentsBatchesHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-shipments-batches';
import {
  barcodeContent as gotoShipmentsEODBarcode,
  messages as gotoShipmentsEodMessages,
  hotkey as gotoShipmentsEodHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-shipments-eod';
import {
  barcodeContent as gotoShipmentsFulfillmentsBarcode,
  messages as gotoShipmentsFulfillmentsMessages,
  hotkey as gotoShipmentsFulfillmentsHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-shipments-fulfillments';
import {
  barcodeContent as gotoShipmentsPickupBarcode,
  messages as gotoShipmentsPickupMessages,
  hotkey as gotoShipmentsPickupHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-shipments-pickup';
import {
  barcodeContent as gotoShipmentsReturnsBarcode,
  messages as gotoShipmentsReturnsMessages,
  hotkey as gotoShipmentsReturnsHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-shipments-returns';
import {
  barcodeContent as gotoShipmentsShipmentsBarcode,
  messages as gotoShipmentsShipmentsMessages,
  hotkey as gotoShipmentsShipmentsHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-shipments';
import {
  barcodeContent as gotoShipstationBarcode,
  messages as gotoShipstationMessages,
  hotkey as gotoShipstationHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-shipstation-connect-settings';
import {
  barcodeContent as gotoStoreBarcode,
  messages as gotoStoreMessages,
  hotkey as gotoStoreHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-store-setup-settings';
import {
  barcodeContent as gotoSubscriptionBarcode,
  messages as gotoSubscriptionMessages,
  hotkey as gotoSubscriptionHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/goto-subscription-settings';

export default [
  {
    barcodeContent: gotoAccountBarcode,
    intlFormattedName: gotoAccountMessages.name,
    hotkey: gotoAccountHotkey,
  },
  {
    barcodeContent: gotoCarrierBarcode,
    intlFormattedName: gotoCarrierMessages.name,
    hotkey: gotoCarrierHotkey,
  },
  {
    barcodeContent: gotoCustomersBarcode,
    intlFormattedName: gotoCustomersMessages.name,
    hotkey: gotoCustomersHotkey,
  },
  {
    barcodeContent: gotoOrdersBarcode,
    intlFormattedName: gotoOrdersMessages.name,
    hotkey: gotoOrdersHotkey,
  },
  {
    barcodeContent: gotoPrintBarcode,
    intlFormattedName: gotoPrintMessages.name,
    hotkey: gotoPrintHotkey,
  },
  {
    barcodeContent: gotoProductsBarcode,
    intlFormattedName: gotoProductsMessages.name,
    hotkey: gotoProductsHotkey,
  },
  {
    barcodeContent: gotoProductsInventoryBarcode,
    intlFormattedName: gotoProductsInventoryMessages.name,
    hotkey: gotoProductsInventoryHotkey,
  },
  {
    barcodeContent: gotoShipmentsBatchesBarcode,
    intlFormattedName: gotoShipmentsBatchesMessages.name,
    hotkey: gotoShipmentsBatchesHotkey,
  },
  {
    barcodeContent: gotoShipmentsEODBarcode,
    intlFormattedName: gotoShipmentsEodMessages.name,
    hotkey: gotoShipmentsEodHotkey,
  },
  {
    barcodeContent: gotoShipmentsFulfillmentsBarcode,
    intlFormattedName: gotoShipmentsFulfillmentsMessages.name,
    hotkey: gotoShipmentsFulfillmentsHotkey,
  },
  {
    barcodeContent: gotoShipmentsPickupBarcode,
    intlFormattedName: gotoShipmentsPickupMessages.name,
    hotkey: gotoShipmentsPickupHotkey,
  },
  {
    barcodeContent: gotoShipmentsReturnsBarcode,
    intlFormattedName: gotoShipmentsReturnsMessages.name,
    hotkey: gotoShipmentsReturnsHotkey,
  },
  {
    barcodeContent: gotoShipmentsShipmentsBarcode,
    intlFormattedName: gotoShipmentsShipmentsMessages.name,
    hotkey: gotoShipmentsShipmentsHotkey,
  },
  {
    barcodeContent: gotoShipstationBarcode,
    intlFormattedName: gotoShipstationMessages.name,
    hotkey: gotoShipstationHotkey,
  },
  {
    barcodeContent: gotoStoreBarcode,
    intlFormattedName: gotoStoreMessages.name,
    hotkey: gotoStoreHotkey,
  },
  {
    barcodeContent: gotoSubscriptionBarcode,
    intlFormattedName: gotoSubscriptionMessages.name,
    hotkey: gotoSubscriptionHotkey,
  },
];
